import { ca } from '@cian/analytics';
import { EServiceId } from '../../../../../../types/reducers/publishTerms';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../../../types/analytics';

interface ITrackPackagesLayoutShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  activeServiceId: EServiceId;
  bet: number | null;
  offerPosition: number | null;
  page: number | null;
}

export const trackPackagesLayoutShow = (params: ITrackPackagesLayoutShowParams) => {
  const { analyticsOfferStatus, analyticsProduct, offerPosition, page, bet, activeServiceId } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show',
    label: 'short',
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest_webview',
        vas: activeServiceId,
        bid: bet,
        position: offerPosition,
        page_number: page,
      },
    },
  });
};
